import { pxToRem } from '@back-office/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

export interface GcpDialogProps {
  handleClose: () => void;
  handleCancel?: () => void;
  handleOk?: () => void;
  open: boolean;
  title?: string;
  message?: string;
  isAlert?: boolean;
  cancelBtn?: string;
  okBtn?: string;
}

const useStyles = makeStyles(
  (theme) => ({
    title: {
      padding: theme.spacing(4, 3),
      '&:first-letter': {
        textTransform: 'capitalize',
      },
      fontSize: pxToRem(17),
      fontWeight: 500,
    },
    actions: {
      padding: theme.spacing(3),
    },
    alert: {
      padding: theme.spacing(3),
      '& > button:first-child': {
        margin: theme.spacing(0, 2),
      },
    },
    content: {
      fontSize: pxToRem(14),
      fontWeight: 400,
    },
  }),
  { name: 'GcpDialog' }
);

const GcpDialog: FC<GcpDialogProps> = (props: GcpDialogProps) => {
  const {
    handleClose,
    handleCancel,
    handleOk,
    open,
    message,
    isAlert,
    cancelBtn,
    okBtn,
    title,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle classes={{ root: classes.title }} id="simple-dialog-title">
        {title ? t(title) : t('dialog.common_title')}
      </DialogTitle>
      {message && (
        <DialogContent>
          <DialogContentText className={classes.content}>
            {t(message)}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions
        disableSpacing
        classes={{ root: isAlert ? classes.alert : classes.actions }}
      >
        {isAlert && (
          <Button
            color="primary"
            size="large"
            onClick={handleCancel || handleClose}
          >
            {cancelBtn ? t(cancelBtn) : t('dialog.cancel')}
          </Button>
        )}
        <Button
          color="primary"
          size="large"
          variant="contained"
          onClick={handleOk || handleClose}
        >
          {okBtn ? t(okBtn) : t('dialog.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(GcpDialog);
